import Card from "components/card";
import TelaMenu from "./TelaMenu";
import { DataGrid } from "@mui/x-data-grid";
import { columns } from "../columns";
import TelaDrawer from "./TelaDrawer";
import React, { useState, useEffect } from "react";
import { getAllTelas } from "../functions";
import { Box, CircularProgress, Typography, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TelaDelete from "./TelaDelete";
import DataGridMarifer from "components/dataGridMarifer/dataGridMarifer";

const TelasTable = () => {
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [mode, setMode] = useState("POST");
  const [telaData, setTelaData] = useState(null);
  const [dataColumns, setDataColumns] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      let telas = await getAllTelas();
      setTelaData(telas);
    };
    fetchData();
    let col = columns(setOpen, setMode, setOpenDelete, dispatch);
    setDataColumns(col);
  }, [open, openDelete, dispatch]);

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Box sx={{ height: "750px", width: "100%" }}>
      <TelaDelete openDelete={openDelete} setOpenDelete={setOpenDelete} />
      <TelaDrawer open={open} handleClose={handleClose} mode={mode} />
      <Card extra={"w-full h-full p-4"}>
        <div className="relative flex items-center justify-end">
          <Tooltip title="Agregar Nueva Tela" placement="top">
            <button
              onClick={() => {
                setOpen(true);
                setMode("POST");
              }}
              className="flex min-w-[80px] items-center
                                    justify-center rounded-md bg-pink-500
                                    px-3 py-2 text-white shadow-md transition hover:bg-pink-600
                                    active:bg-pink-700"
            >
              <AddCircleIcon className="text-white" />
            </button>
          </Tooltip>
        </div>
        {telaData ? (
          <DataGridMarifer rows={telaData || []} columns={dataColumns || []} />
        ) : (
          <div className="flex justify-center pt-56">
            <CircularProgress color="primary" />
            <Typography>Cargando datos...</Typography>
          </div>
        )}
      </Card>
    </Box>
  );
};
export default TelasTable;
